import React from 'react';
import CountUp from 'react-countup';
import Loadable from '@loadable/component';

import './impact.styles.scss';

const Jump = Loadable(() => import('react-reveal/Jump'));

type ImpactType = {
  title: string;
  description: JSX.Element | string;
  bulletPoints: {
    icon: JSX.Element;
    text: JSX.Element | string;
  }[];
};

const impacts: ImpactType[] = [
  {
    title: 'Environmental Impact',
    description:
      'We are committed to taking action against climate change and reducing our impact on the environment.',
    bulletPoints: [
      {
        icon: <i className="flaticon-tick"></i>,
        text: (
          <>
            Removed: <CountUp end={14.7} suffix=" tonnes of " separator="," />
            CO<sub>2</sub>
          </>
        ),
      },
      {
        icon: <i className="flaticon-tick"></i>,
        text: (
          <>
            Saved <CountUp end={44} suffix=" trees" separator="," />
          </>
        ),
      },
    ],
  },
  {
    title: 'Social Impact',
    description: (
      <>
        We bridge the gap to access better opportunities. <br />
        <br />
        <br />
      </>
    ),
    bulletPoints: [
      {
        icon: <i className="flaticon-tick"></i>,
        text: 'Help people from marginalized communities retain better jobs',
      },
      {
        icon: <i className="flaticon-tick"></i>,
        text: 'Reduce stress and mental health impacts',
      },
    ],
  },
  {
    title: 'Day to Day Impact',
    description: (
      <>
        Since inception, Hop In has helped to simplify the daily commute. <br />
        <br />
      </>
    ),
    bulletPoints: [
      {
        icon: <i className="flaticon-tick"></i>,
        text: (
          <>
            Total KM serviced:{' '}
            <CountUp end={50000} suffix=" km" separator="," />
          </>
        ),
      },
      {
        icon: <i className="flaticon-tick"></i>,
        text: (
          <>
            Total rides: <CountUp end={10000} suffix=" rides" separator="," />
          </>
        ),
      },
    ],
  },
];

const Impact = () => {
  return (
    <div className="pt-100 pb-70">
      <div className="container">
        <div className="section-title">
          <span className="sub-title">Our Impact</span>
          <h2>Types of Impacts</h2>
        </div>

        <div className="row align-items-center">
          <div className="container">
            <div className="about-inner">
              <div className="row">
                {impacts.map(({ title, description, bulletPoints }, i) => (
                  <div className="col-lg-4 col-md-6 col-sm-6" key={i}>
                    <div className="about-text">
                      <h3>{title}</h3>
                      <p>{description}</p>

                      <Jump cascade>
                        <ul className="features-list">
                          {bulletPoints.map(({ icon, text }) => (
                            <li>
                              {icon} {text}
                            </li>
                          ))}
                        </ul>
                      </Jump>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impact;
